<template>
  <div style="display: none;">
    <input
      v-if="showInput"
      ref="file-input"
      type="file"
      :accept="acceptTypes"
      @change="onFileChange"
      :placeholder="$t('please_select')"
      multiple
    />
  </div>
</template>
<script>
export default {
  name: "add-material-popper",
  props: {
    materialType: String
  },
  data() {
    return {
      fileValidate: false,
      
      accepts:{
          video: ".mp4,.mpeg,.mpg,.webm",
          photo: ".gif,.png,.jpg,.jpeg",
          audio: ".ogg,.wav,.mp3"
      },
      sizeLimits: {
          video: 20 * 1024 * 1024,
          photo: 100 * 1024 * 1024,
          audio: 100 * 1024 * 1024,
      },
      fileErrorMessage: "",
      filesData: [],
      showInput: true
    };
  },
  computed: {
    acceptTypes() {
      return this.accepts[this.materialType];
    },
    uploadMediaType(){
      if(this.materialType === "photo" || this.materialType === "video"){
        return "media";
      } else if(this.materialType === "audio"){
        return "audio";
      }
    },
    canConfirm() {
      return this.fileValidate;
    },
    acceptSize(){
      return this.sizeLimits[this.materialType];
    }
  },
  watch: {
    filesData(value){
      if(!value || value.length === 0){
        return;
      }
      this.showInput = false;
      this.$nextTick(() => {
        this.confirm();
        this.showInput = true;
      })
    }
  },
  methods: {
    startSelectFile(){
      this.$refs["file-input"] && this.$refs["file-input"].click();
    },
    
    onFileChange(event) {
        let files = event.target.files, file;
        
        let filesData = [];
        if(files.length === 0){
          return this.filesData = filesData;
        }
        for(let i = 0,len = files.length;i < len;i++){
          file = files[i];
          if (/\.(gif|jpg|jpeg|png)$/.test(file.name)) {
            ((currentFile) => {
              const fileReader = new FileReader();
              fileReader.onload = (e) => {
                filesData.push({
                  file: currentFile,
                  title: currentFile.name,
                  type: this.uploadMediaType,
                  screenshot: e.target.result
                });
                if(filesData.length === files.length){
                  this.filesData = filesData;
                }
              };
              fileReader.readAsDataURL(file);
            })(file);
          } else {
            filesData.push({
              file,
              title: file.name,
              type: this.uploadMediaType,
              screenshot: ""
            });
            if(filesData.length === files.length){
              this.filesData = filesData;
            }
          }
        }
    },
    
    validateFile(filesData) {
      if (filesData.length === 0) {
        this.fileErrorMessage = "";
        this.fileValidate = false;
        return false;
      }
      let acceptTypes = this.acceptTypes.replace(/\./g, "");
      let file, fileNameArr, fileType, isValidate = true;
      acceptTypes = acceptTypes.split(",");
      for(let i = 0,len = this.filesData.length;i < len;i++){
        file = this.filesData[i].file;
        fileNameArr = file.name.split(".");
        fileType = fileNameArr.pop() || "";
        console.log("file size:",file.size);
        if (acceptTypes.includes(fileType)) {
          if(file.size > this.acceptSize){
            event.target.value = "";
            this.filesData = [];
            this.fileErrorMessage = `${this.$t("message.warn_upload_size_limit")}${Math.floor(this.acceptSize / (1024 * 1024))}MB`;
            this.fileValidate = false;
            isValidate = false;
            break;
          } else {
              this.fileValidate = true;
              this.fileErrorMessage = "";
          }
        } else {
          event.target.value = "";
          this.filesData = [];
          this.fileErrorMessage = `${this.$t("support_material_format")}:${acceptTypes.join("、")}`;
          this.fileValidate = false;
          isValidate = false;
          break;
        }
      }
      return isValidate;
    },
    
    confirm() {
      if (!this.validateFile(this.filesData)) {
        this.$message.error(this.fileErrorMessage);
        return;
      }
      this.$emit("confirm", this.filesData);
    },
  }
};
</script>
<style lang="scss">
.add-material-dialog {
  .el-dialog__header {
    .popper-title {
      font-size: 18px;
      line-height: 60px;
      color: #ffffff;
      .material-type {
        color: #45e5f4;
      }
    }
  }
  .el-dialog__body {
    padding-bottom: 0;
    .el-form {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          padding-right: 12px;
          color: #a8a8ac;
        }
        .el-form-item__content {
          position: relative;
          .el-input {
            .el-input__inner {
              background: #333333;
              color: #a8a8ac;
              border-color: #696969;
              height: 32px;
              line-height: 30px;
              &:focus {
                color: #45e5f4;
                border-color: #45e5f4;
              }
            }
          }
          .file-input-container {
            width: 100%;
            height: 100%;
            overflow: hidden;
            .file-input {
              width: 120px;
              height: 32px;
              line-height: 30px;
              border-radius: 16px;
              text-align: center;
              padding: 0 15px;
              font-size: 14px;
              float: left;
              position: relative;

              input {
                width: 100%;
                height: 100%;
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                cursor: pointer;
              }
            }
            .file-name {
              float: left;
              width: calc(100% - 120px);
              padding: 0px 14px;
              line-height: 32px;
              font-size: 13px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #696969;
            }
          }
          .files-list{
            padding: 12px 0;
            li{
              width: 100%;
              line-height: 32px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #ffffff;
            }
          }
          .el-form-item__error {
            padding-top: 6px;
            text-align: left;
          }
        }
      }
      .img-thumb {
        width: 200px;
        height: 140px;
        margin-bottom: 18px;
        margin-left: 101px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .el-dialog__footer{
    .footer-button-group{
      .codelab-button{
        outline: none;
        height: 32px;
        width: 120px;
        font-size: 15px;
        border-radius: 16px;
        margin-left: 18px;
      }
    }
  }
}
</style>
